import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Login from './pages/auth/Login';
import Shell from './components/layout/Shell';

function AppInner() {
  const { currentUser } = useApp();
  return currentUser ? <Shell /> : <Login />;
}

export default function App() {
  return (
    <AppProvider>
      <AppInner />
    </AppProvider>
  );
}
